import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'stone' | 'outline';
  children: ReactNode;
}

export function Card({ variant = 'default', className, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={clsx(
        'rounded-md p-6',
        variant === 'default' && 'bg-canvas-white border border-hairline',
        variant === 'stone' && 'bg-soft-stone border border-transparent',
        variant === 'outline' && 'bg-canvas-white border border-hairline',
        className
      )}
    >
      {children}
    </div>
  );
}
